import { mapDataForStoreInfo } from 'utils';
import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  selectedReservation: {},
  storeData: {},
  loading: false,
  error: null,
};

const mapReservationProducts = (products) =>
  products.map((product) => ({
    ...product,
    brandName: product.designerName,
    name: product.productName,
    currentPrice: product.itemPrice,
    itemQty: product.quantity,
  }));

const mapReservationDetails = (reservationData) => {
  const {
    clientName,
    clientPhoneNumbers,
    posItems,
    expiryDate,
    reservationDate,
    reservationId,
    totalAmount,
    storeNumber,
    cmdUri,
  } = reservationData;

  const mappedDetails = {
    clientData: { name: clientName, phoneNumber: clientPhoneNumbers[0], cmdUri },
    productData: mapReservationProducts(posItems),
    reservationData: {
      reservationId,
      reservationExpiryDate: expiryDate,
      reservationDate,
      reservationSubtotal: totalAmount && `${totalAmount}`,
      reservationStoreId: storeNumber,
    },
  };

  return mappedDetails;
};

const reservationsDetails = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.RESERVATION_STORE_DETAILS_LOADING:
    case actions.RESERVATION_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.RESERVATION_DETAILS_SUCCESS:
      return {
        ...state,
        selectedReservation: mapReservationDetails(payload),
        loading: false,
      };
    case actions.RESERVATION_STORE_DETAILS_SUCCESS:
      return {
        ...state,
        storeData: mapDataForStoreInfo(payload),
        loading: false,
      };
    case actions.RESERVATION_DETAILS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.RESERVATION_DETAILS_CLEAR:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default reservationsDetails;
